<script setup lang="ts">
import type { CtaData } from '~/utils/crystallize/pieces'
import { faArrowRightLong } from '@fortawesome/pro-regular-svg-icons'
import { getCtaProps } from '~/utils/crystallize/cta'

const props = defineProps<{
  data: CtaData
}>()

const cta = computed(() => getCtaProps(props.data))
</script>

<template>
  <ContentGrid class="text-moss-200 w-full">
    <div class="bg-moss-500 rounded-4xl col-span-full flex flex-col lg:flex-row items-center py-l gap-y-m gap-x-40 lg:px-2xl lg:py-xl">
      <CrystallizeImage v-if="cta.image" :image="cta.image" class="hidden md:block" />

      <div class="flex flex-col gap-s lg:gap-m items-center lg:items-start flex-1">
        <h2 class="title-s !font-light md:title-l md:!font-semibold" v-text="data.title" />

        <CrystallizeRichText
          v-for="(block, i) in data.text"
          :key="i"
          :block="block"
          class="text-2xl font-heading font-light"
        />

        <ResponsiveButton v-if="cta.action" color="moss" variant="secondary" :to="cta.action.link" class="dark-mode group">
          {{ cta.action.label || cta.action.link }}
          <Icon :icon="faArrowRightLong" class="group-hover:translate-x-2 transition-transform" />
        </ResponsiveButton>
      </div>
    </div>
  </ContentGrid>
</template>
